export function useFacebookPixel() {
  const { $fbq, $versions } = useNuxtApp();
  let PIXEL_ID = '610922901428415';

  if ($versions.value.landing === '16' || $versions.value.landing === '17') {
    PIXEL_ID = '1635665980452739';
  }

  const initPixel = (): void => {
    if (import.meta.client) {
      ($fbq as any)?.('init', PIXEL_ID);
    }
  };

  const fbqTrack = (event: string): void => {
    if (import.meta.client) {
      ($fbq as any)?.('trackSingleCustom', PIXEL_ID, event);
    }
  };

  const fbqCustomTrack = (event: string): void => {
    if (import.meta.client) {
      ($fbq as any)?.('trackSingleCustom', PIXEL_ID, event);
    }
  };

  return {
    fbqTrack,
    initPixel,
    fbqCustomTrack,
    pixelId: PIXEL_ID,
  };
}
